module.exports = __webpack_public_path__ + "img/group3.2cc2c531.png";